<script>
import { Sprite, Container, Graphics } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene5',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
  },

  created() {

    const sprites = {}
    this.$sprites = sprites
    
    const container = new Container()
    this.setCenterContainer(container)
    container.addChild(this.createBg())

    const mask = new Container()
    this.setCenterContainer(mask)
    container.addChild(mask)

    const mask_second = new Container()
    this.setCenterContainer(mask_second)
    container.addChild(mask_second)

    this.$container.addChild(container)
    this.$parent.$scene5 = container

    const tl = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {
      'bg': { container: container, alpha: .5, position: { x: 0, y: 0, width: 1536, height: 2160 } },
    }

    _.each(els, (el, name)=>{
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const stars = []
    const masks = []
    const nb = 30

    let compte = 0
    let psx = [ 100, 800, 110, 150, 220, 400, 420, 500, 590, 730, 800, 900, 980, 1010, 1110, 1200, 1280, 1350, 1400, 1450 ]
    let psy = [ 500, 800, 110, 150, 300, 330, 450, 500, 630, 800, 840, 900, 950, 1130, 1330, 1420, 1640, 1700, 1800, 1600 ]

    psx = _.shuffle(psx)
    psy = _.shuffle(psy)

    for(let i=0; i<nb; i++) {

      if(i === nb/2){
        sprites['bg_lines'] = new Sprite.from(this.$resources['bg_lines'].texture)
        sprites['bg_lines'].scale.set(this.$root.$scale)
        sprites['bg_lines'].anchor.set(.5)
        sprites['bg_lines'].alpha = 0
        container.addChild(sprites['bg_lines'])
      }

      const img = (i<nb/2) ? 'bg_lines' : 'front'
      const sprite = new Sprite.from(this.$resources[img].texture)
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = 1

      container.addChild(sprite)
      sprites['front'+ i] = sprite

      const pos = { x: psx[compte], y: psy[compte] }
      compte ++

      if(compte === (nb/2)-1) {
        compte = 0
        psx = _.shuffle(psx)
        psy = _.shuffle(psy)
      }

      const mask = new Sprite.from(this.$resources['flare'+ _.random(1,2)].texture)
            mask.anchor.set(0.5)
            mask.scale.set(0)

      const ix = -384+(pos.x/2)
      const iy = -540+(pos.y/2)

      TweenMax.set(mask, { x: ix, y: iy })
      sprites['front'+ i].mask = mask
      container.addChild(mask)
      masks.push(mask)

      sprites['star'+ i] = new Sprite.from(this.$resources['star'].texture)
      sprites['star'+ i].scale.set(_.random(2, 3))
      sprites['star'+ i].anchor.set(.5)
      sprites['star'+ i].x = ix
      sprites['star'+ i].y = iy
      sprites['star'+ i].alpha = 0
      sprites['star'+ i].tint = 0xfffffe
      container.addChild(sprites['star'+ i])
      stars.push(sprites['star'+ i])
    }

    sprites['front'] = new Sprite.from(this.$resources['front'].texture)
    sprites['front'].scale.set(this.$root.$scale)
    sprites['front'].anchor.set(.5)
    sprites['front'].alpha = 0
    container.addChild(sprites['front'])

    // ******************************************************** //
    // ******************************************************** //

    const getFlash = (index, delay)=>{
      // const delay = Math.round(_.random(array[0], array[1])*100)/100
      const tml = new TimelineMax()
            .add([
              TweenMax.to(masks[index], .5, { pixi:{ scale: _.random(.75, 1.4) }, ease: Cubic.easeOut, delay: delay }),
              // TweenMax.to(stars[index], .1, { pixi:{ alpha: _.random(.2, .5)}, delay: delay - .05 }),
              TweenMax.to(stars[index], .25, { pixi:{ alpha: 0, scale: 0 }, ease: Cubic.easeIn, delay: delay }),
            ])
      return tml
    }

    tl.add([

      getFlash(0, .5),
      getFlash(1, .75),
      getFlash(2, 1.1),
      getFlash(3, 2),
      //
      getFlash(6, 3),
      getFlash(7, 3.25),
      getFlash(8, 3.5),
      // // 
      getFlash(11, 5),
      getFlash(12, 5.2),
      getFlash(4, 5.4),
      getFlash(13, 5.6),
      getFlash(14, 6.25),

      // getFlash(0, [.5, 1]),
      // getFlash(1, [.5, 1]),
      // getFlash(2, [1, 1.5]),
      // getFlash(3, [1.25, 2.25]),
      // // getFlash(4, [2.5, 3]),
      // // getFlash(5, [2.75, 3.75]),
      // getFlash(6, [3.25, 4.25]),
      // getFlash(7, [3, 4.25]),
      // getFlash(8, [4.5, 5.25]),
      // // getFlash(9, [5, 5.75]),
      // // getFlash(10, [5.5, 6.25]),
      // getFlash(11, [6, 6.75]),
      // getFlash(12, [6.2, 7]),
      // getFlash(13, [6, 6.5]),
      // getFlash(14, [6.25, 6.5]),

      TweenMax.to(sprites['bg_lines'], .5, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 7 }),

      getFlash(15, 7.25),
      getFlash(16, 7.45),
      getFlash(17, 8.20),
      // // getFlash(18, [(1.25*1.25)+7, (2.25*1.25)+7]),
      getFlash(19, 9),
      getFlash(20, 9.2),
      getFlash(21, 9.5),
      getFlash(22, 10),
      getFlash(23, 10.25),
      
      // getFlash(26, [(6*1.25)+7, (6.75*1.25)+7]),
      // getFlash(29, [(6.25*1.25)+7, (7*1.25)+7]),

    ])

    // tl.to(sprites['front'], 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone })

    const sub1 = new TimelineMax()
          .to(container, 15, { pixi:{ scale: '+=.35' }, ease: Cubic.easeOut })

    this.$tl.add([ tl, sub1 ], 0)

  },
  mounted() {

    // console.log('Scene5');
    // this.$parent.chapter.$tl.seek(51)

  }
}
</script>























